export default {
    // called by Vue.use(FirstPlugin)
    install(Vue, options) {
      // create a mixin
      Vue.prototype.$wll = function (methodOptions) {
        return this.$root.whitelabel.getLanguageUnit()
      };

    },
  };
  